<template>
  <div class="page-content">
    <div class="content">
      <div class="search">
        <el-form :inline="true" :model="filters" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
          <el-form-item label="类型:">
            <el-radio-group v-model="filters.orderType" >
              <el-radio-button v-for="item in typeList" :label="item.value" :key="item.value">{{item.label}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <div class="left">
          <el-table :data="tabData" height="100%"
          header-cell-class-name='table-header-cell' cell-class-name='table-cell'
          border stripe fit  highlight-current-row @row-click='handleRowClick'
          >
            <el-table-column prop="hint" label="巡检模块" min-width="200" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="right">
          <el-table :data="topicData" height="100%"
          header-cell-class-name='table-header-cell' cell-class-name='table-cell'
          border stripe fit  highlight-current-row
          >
            <el-table-column prop="hint" label="巡检项名称" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="hint" label="填写方式" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{answerWay[scope.row.type] || '数组'}}
              </template>
            </el-table-column>
            <!-- <el-table-column fixed="right" label="操作" min-width="100" align="center">
              <template slot-scope="scope">
                <el-button @click.native.prevent="handleEdit(scope.$index, scope.row)" type="text" :size="size" >编辑</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <edit-dialog ref="editDialog" v-if="editDialogVisible"></edit-dialog>
  </div>
</template>

<script>
import editDialog from './editDialog.vue'
export default {
  name: 'standards',
  components: {
    editDialog
  },
  data () {
    return {
      editDialogVisible: false,
      filters: {
        orderType: 4
      },
      typeList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 }
      ],
      answerWay: {
        1: '文本',
        2: '数字',
        3: '图片',
        4: '枚举',
        5: '列表',
      },
      size: 'small',
      tabData: [],
      topicData: []
    }
  },
  created () {
    this.handleQuery()
  },
  methods: {
    handleQuery () {
      // 1 文本, 2 数字, 3 图片, 4 枚举, 5 列表
      this.$api.electricOperations.lookupElectricOperationsWorkOrderDataDict(this.filters.orderType).then((res) => {
        if (res.success) {
          console.log(res.data)
          this.tabData = res.data[0].objectTypes
          this.topicData = this.tabData[0].members
        }
      })
    },
    handleRowClick (row) {
      this.topicData = row.members
    },
    handleEdit (index, row) {
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editDialog.init(row)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  text-align: left;
}

.table-content {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  box-sizing: border-box;
  .left {
    margin-right: 16px;
    width: 200px;
    height: 100%;
  }
  .right {
    width: calc(100% - 216px);
    height: 100%;
  }
}
</style>
